// Birthdate: YYMMDD
const validateBirthDate = (birthDate, lmaNumber) => {
    if (birthDate === "" && lmaNumber === "") {
      return  true;
  }
    let pattern = /^[0-9]{6}$/;
    return pattern.test(birthDate);
};

export default validateBirthDate;